import { Address, Category, FacetChoice } from '@akinon/next/types';

export * from '@theme/types/widgets';

export type RegisterFormType = {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  phone: string;
  confirm: boolean;
  kvkk_confirm: boolean;
  email_allowed: boolean;
  sms_allowed: boolean;
  formType: string;
  locale: string;
  gender?: string | null;
};

export type LoginFormType = {
  email: string;
  password: string;
  formType: string;
  locale: string;
};

export type OtpLoginFormType = {
  phone: string;
  code?: string;
  locale: string;
  formType: string;
};

export enum WIDGET_TYPE {
  category = 'category',
  multiselect = 'multiselect',
  multiple_selection = 'multiple_selection'
}

export type Facet = {
  data: {
    choices: Array<FacetChoice>;
    key: string;
    name: string;
    order: number;
    search_key: string;
    widget_type: string;
  };
  extra_params: any;
  key: string;
  name: string;
  order: number | null;
  search_key: string;
  widget_type: 'category' | 'multiselect' | 'multiple_selection';
};

export interface CreditCardForm {
  card_holder: string;
  card_number: string;
  card_month: string;
  card_year: string;
  card_cvv: string;
  installment: number;
  agreement: boolean;
  save?: boolean;
}

export interface CheckoutAddressType {
  label: string;
  text: string;
  value: Address;
  requestParam: string;
}

export interface PriceProps {
  currencyCode?: string;
  useCurrencySymbol?: boolean;
  useCurrencyAfterPrice?: boolean;
  useCurrencySpace?: boolean;
  useNegative?: boolean;
  useNegativeSpace?: boolean;
}

export interface SeoProps {
  title?: string;
  description?: string;
  keywords?: string;
  itemPropName?: string;
  itemPropDescription?: string;
  itemPropImage?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterData1?: string;
  twitterLabel1?: string;
  ogTitle?: string;
  ogImage?: string;
  ogDescription?: string;
  ogPriceAmount?: string;
  ogPriceCurrency?: string;
}

export interface CategoryWithBanner extends Category {
  attributes: Category['attributes'] & {
    banner?: {
      value: {
        title: null | string;
        tagline: null | string;
        mobile_image: null | string;
        desktop_image: null | string;
        position: null | string;
        text_color: null | string;
      };
      kwargs: {
        value: {
          mobile_image: {
            url: string;
          };
          desktop_image: {
            url: string;
          };
        };
        data_type: 'nested';
      };
    };
  };
}

export interface ResellerApplication {
  name: string;
  lastName: string;
}
export interface StoreAppointment {
  name: string;
  lastname: string;
  email: string;
  phone: string;
  province: string;
  district: string;
  store: string;
  subject: string;
}

export interface PersonalizedAppointment {
  name: string;
  lastname: string;
  email: string;
  phone: string;
  city: string;
  district: string;
  store: string;
}

export interface Review {
  id: number | string;
  rating: string | number;
  rating_types?: Record<string, number>;
  title?: string | null;
  review: string;
  first_name?: string | null;
  last_name?: string | null;
  created_by?: string | null;
  phone?: string | null;
  order_number?: string | null;
  supplier?: string | null;
  is_privated?: boolean;
  is_displayed?: boolean;
  useful?: number;
  status?: string;
  created_date?: string;
  modified_date?: string;
  product?: {
    name?: string;
    sku?: string;
    base_code?: string;
  };
}

export interface ReviewListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Review[];
}

export type ReviewFormType = {
  rating: number;
  review: string;
  full_name?: string;
};

export type ReviewPayload = {
  rating: number;
  review: string;
  sku: string;
  order_number: string;
  order_id?: number | string;
  email?: string;
  full_name?: string;
};

export type GroupedRating = {
  base_code?: string;
  sku?: string;
  avg_rating: number;
  count: number;
};
